import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';

import { logging, logPostInfo } from '../../../actions/log';
import {
  getCategoryImgInfo,
  getCategoryLabels,
  determineBatchShow,
  showBatchAddInfo,
} from '../../../actions/wallpaper';
import Loading from '../../../components/Loading/Loading';
import WallpaperCard from '../../../components/WallpaperCard/WallpaperCard';
import { getQueryString } from '../../../utils/utils';
import Blank from '../Blank';
import Nav from '../Nav';
import styles from './WallpaperCategory.module.less';
import WallpaperCategoryNav from '../WallpaperCategoryNav';
// import InfiniteScroll from 'react-infinite-scroller';
import useResize from '../../../utils/hooks/useResize';
import ScrollTop from '../../../components/ScrollTop/ScrollTop';
import InfiniteScroll from '../../../components/InfinteScroll/AutoHeightGridInfinteScroll';
import DefaultImage from '../../../static/wp_default.svg';
import ScrollTopWhite from '../../../components/ScrollTopWhite/ScrollTopWhite';
import BatchAdd from '../WallpaperComponents/BatchAdd';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import Toast from '../../../components/Toast/Toast';
import { getVipState } from '../../../actions/wallpaperPay';
import { updateShowWpOrder, emptyBtnAdd } from '../../../actions/wallpaper';
import Config from '../config';

const selectWpCategoryLabels = createSelector(
  state => {
    return state.wallpaper && state.wallpaper;
  },
  info => info.labelList || [],
);

const selectWpCategoryImgInfo = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.categoryInfo;
  },
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const SelectWpBatchAddShow = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpBatchAddShow,
);

const SelectVipState = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.vipState,
);

const SelectWpBatchInfoShow = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpBatchInfoShow,
);

function WPCategory() {
  const [load, setLoad] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { action, search } = history;
  const [activeClass, setActiveClass] = useState('-1');
  const [activeTag, setActiveTag] = useState('-1');
  const [activePrice, setActivePrice] = useState('-1');

  const [tagList, setTagList] = useState([]);
  const [priceList, setPriceList] = useState([]);
  const classList = useSelector(selectWpCategoryLabels);
  const categoryImgInfo = useSelector(selectWpCategoryImgInfo);
  const logInfoData = useSelector(selectLogInfo);

  const [initTime, setInitTime] = useState(+new Date());
  const [pageContent, setPageContent] = useState(null);
  const [columnMap, setColumnMap] = useState({});
  const columnWidth = [250, 385, 250];
  const columnCountByScreen = {
    1030: [4, 2, 4],
    1175: [4, 3, 4],
    1290: [5, 3, 5],
    1550: [6, 3, 6],
    1570: [6, 4, 6],
  };
  const [el, setEl] = useState(null);
  const [batchText, setBatchText] = useState({
    info: null,
    classid: null,
    tagid: null,
    page: 'category',
  }); // 设置不同tag的批量添加文字展示
  const wpBatchAddShow = useSelector(SelectWpBatchAddShow);
  const LoginStatus = useLoginStatus();
  const [batchAddBtn, setBatchAddBtn] = useState({ isShow: false, class: null, tag: null });
  const [onLogin, setOnLogin] = useState(false);
  const wpVip = useSelector(SelectVipState);
  const wpBatchInfoShow = useSelector(SelectWpBatchInfoShow);

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Wallpaper_Category||${activeClass}||${activeTag}||${activeTag}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime, activeClass, activeTag]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Category',
        label: '',
        param2: {
          source: `Wallpaper_Category||${activeClass}||${activeTag}||${activeTag}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  // useActivate(() => {
  //   pagePvLog();
  // });

  const getScrollList = useCallback(pagenation => {
    dispatch(
      getCategoryImgInfo({
        ...categoryImgInfo.pagenation,
        ...pagenation,
      }),
    );
  });

  useEffect(() => {
    getScrollList({
      tagId: activeTag,
      classId: activeClass,
      skip: 0,
      refresh: true,
      priceId: activePrice,
    });
  }, [activeClass, activeTag, activePrice]);
  useEffect(() => {
    dispatch(getCategoryLabels());
  }, []);

  const handleClass = useCallback(
    classifyId => () => {
      if (classifyId !== activeClass) {
        setActiveClass(classifyId);

        const { tags: tagLists, priceList: priceLists } = classList.find(
          item => item.classifyId === classifyId,
        );
        setTagList(tagLists || []);
        setActiveTag(tagLists[0] && tagLists[0].tagId);
        setPriceList(priceLists || []);
        // setOnLogin(false);
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'C_Wallpaper_Category_Tag',
            label: '',
            param2: {
              source: `Wallpaper_Category||${classifyId}||${tagLists[0] &&
                tagLists[0].tagId}||${activePrice}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    },
    [activeClass, classList, onLogin],
  );
  useEffect(() => {
    if (classList[0] && (action === 'PUSH' || tagList.length === 0)) {
      const classId = getQueryString('classId', search) || '-1';
      const tagId = getQueryString('tagId', search) || '-1';
      // setActiveClass(classId);
      // setActiveTag(tagId);
      // const { tags: tagLists, priceList: priceLists } =
      //   classList.find(item => item.classifyId === classId) || {};
      // setTagList(tagLists || []);
      // setPriceList(priceLists);
      let tagLists = [];
      let priceLists = [];
      if (!classList.find(item => item.classifyId === classId)) {
        setActiveClass('-1');
        tagLists = classList.find(item => item.classifyId === '-1')?.tags;
        priceLists = classList.find(item => item.classifyId === '-1')?.priceList;
      } else {
        setActiveClass(classId);
        tagLists = classList.find(item => item.classifyId === classId)?.tags;
        priceLists = classList.find(item => item.classifyId === classId)?.priceList;
      }
      if (tagLists && tagLists.length > 0) {
        if (!tagLists.find(item => item.tagId === tagId)) {
          setActiveTag('-1');
        } else {
          setActiveTag(tagId);
        }
      }
      setTagList(tagLists);
      setPriceList(priceLists);
    }
  }, [classList, search]);

  useEffect(() => {
    if (pageContent) {
      setEl(pageContent.querySelector('#InfiniteScroll').querySelector('div'));
    }
  }, [pageContent]);

  useEffect(() => {
    if (LoginStatus) {
      if (activeClass !== '-1' || activeTag !== '-1') {
        dispatch(
          determineBatchShow({
            groupType: 2,
            isShow: false,
            classifyId: activeClass,
            tagId: activeTag,
          }),
        );
      }
    }

    dispatch(
      logPostInfo({
        source: `Wallpaper_Category||${activeClass}||${activeTag}||${activePrice}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [activeClass, activeTag, LoginStatus]);

  useEffect(() => {
    if (wpBatchAddShow.isShow) {
      if (wpBatchAddShow.isChange && wpBatchAddShow.groupType === 2) {
        if (!sessionStorage.getItem('FIRST_WP_CATEGORY')) {
          sessionStorage.setItem('FIRST_WP_CATEGORY', 1);
          dispatch(showBatchAddInfo(true));
        } else {
          sessionStorage.setItem(
            'FIRST_WP_CATEGORY',
            ~~sessionStorage.getItem('FIRST_WP_CATEGORY') + 1,
          );
          dispatch(showBatchAddInfo(false));
        }
      }
      determinebtnText();
    }
  }, [wpBatchAddShow]);

  useEffect(() => {
    return () => {
      dispatch(emptyBtnAdd());
    };
  }, []);

  useEffect(() => {
    if (!LoginStatus) {
      if (activeClass === '-1' && activeTag === '-1') {
        setBatchAddBtn({ isShow: false, class: null, tag: null });
      } else {
        setBatchAddBtn({ isShow: true, class: activeClass, tag: activeTag });
      }
    } else {
      if (activeClass === '-1' && activeTag === '-1') {
        setBatchAddBtn({ isShow: false, class: null, tag: null });
      } else {
        if (wpBatchAddShow.isShow) {
          setBatchAddBtn({ isShow: true, class: activeClass, tag: activeTag });
        } else {
          setBatchAddBtn({ isShow: false, class: null, tag: null });
        }
      }
    }
  }, [wpBatchAddShow, LoginStatus, activeClass, activeTag]);

  useEffect(() => {
    if (!LoginStatus && batchAddBtn.isShow) {
      if (!sessionStorage.getItem('FIRST_WP_CATEGORY')) {
        sessionStorage.setItem('FIRST_WP_CATEGORY', 1);
        dispatch(showBatchAddInfo(true));
      } else {
        sessionStorage.setItem(
          'FIRST_WP_CATEGORY',
          ~~sessionStorage.getItem('FIRST_WP_CATEGORY') + 1,
        );
        dispatch(showBatchAddInfo(false));
      }
      determinebtnText();
    }
  }, [LoginStatus, batchAddBtn]);

  const determinebtnText = () => {
    let classInfo = classList.find(e => e.classifyId === activeClass);
    let tagInfo = tagList.find(e => e.tagId === activeTag);

    //   if (activeClass !== '-1') {
    //     setBatchText({
    //       info: classInfo.classifyName,
    //       classid: activeClass,
    //       tagid: activeTag,
    //       page: 'category',
    //     });
    //     // setBatchText(classInfo.classifyName);
    //   } else {
    //     if (activeTag !== '-1') {
    //       setBatchText({
    //         info: tagInfo.tagName,
    //         classid: activeClass,
    //         tagid: activeTag,
    //         page: 'category',
    //       });
    //       // setBatchText(tagInfo.tagName);
    //     } else {
    //       return;
    //     }
    //   }
    // };
    if (activeTag !== '-1') {
      setBatchText({
        info: tagInfo.tagName,
        classid: activeClass,
        tagid: activeTag,
        page: 'category',
      });
    } else {
      if (activeClass !== '-1') {
        setBatchText({
          info: classInfo.classifyName,
          classid: activeClass,
          tagid: activeTag,
          page: 'category',
        });
      } else {
        return;
      }
    }
  };

  const callbackOrder = useCallback(
    flag => {
      if (flag) {
        determineVip({
          groupType: 2,
          classifyId: activeClass,
          tagId: activeTag,
        });
      }
    },
    [wpVip, activeClass, activeTag, batchText],
  );

  const determineVip = useCallback(
    async param => {
      const ret = await Config.batchAddShow(param);
      if (ret?.status === 0) {
        if (ret?.data?.hasCarousel === 1) {
          Toast.error({ content: `${batchText.info}已在您的轮播列表中` });
        } else if (ret?.data?.hasCarousel === 0) {
          let res = await Config.batchAdd(param);
          if (res === false) {
            Toast.error({ content: '添加失败' });
          } else {
            if (res.status === 0) {
              Toast.success({ content: '添加成功' });
              dispatch(
                determineBatchShow({
                  ...param,
                  isShow: false,
                }),
              );
              dispatch(
                logging({
                  category: 'Wallpaper',
                  action: 'R_Wallpaper_Resiguid_Result',
                  label: '',
                  param2: {
                    source: `Wallpaper_Category||${activeClass}||${activeTag}||${activePrice}`,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                  },
                }),
              );
            } else {
              Toast.error({ content: res.message });
            }
          }
        }
      } else if (ret?.status === 2) {
        dispatch(
          updateShowWpOrder({
            show: true,
            wallpaperId: '',
            code: '',
            wpType: 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
            scenetype: 'resident', // 'set', 'dl', 'resident','resident_category', 'loop_single', 'loop_batch', 'loop_start'
            callbackTurnOrder: callbackOrder,
          }),
        );
      }
      setOnLogin(false);
    },
    [activeClass, activeTag, batchText],
  );

  // 新增在登录后判断是否添加过轮播
  useEffect(() => {
    if (LoginStatus && onLogin) {
      determineVip({
        groupType: 2,
        classifyId: activeClass,
        tagId: activeTag,
      });
    }
  }, [LoginStatus, onLogin]);

  const handleTag = useCallback(
    tagId => () => {
      if (activeTag !== tagId) {
        setActiveTag(tagId);
        // setOnLogin(false);
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'C_Wallpaper_Category_Tag',
            label: '',
            param2: {
              source: `Wallpaper_Category||${activeClass}||${tagId}||${activePrice}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    },
    [tagList, activeTag, activeClass, onLogin],
  );

  const handlePrice = useCallback(
    type => () => {
      if (activePrice !== type) {
        setActivePrice(type);
        // setOnLogin(false);
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'C_Wallpaper_Category_Tag',
            label: '',
            param2: {
              source: `Wallpaper_Category||${activeClass}||${activeTag}||${type}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    },
    [activePrice, onLogin],
  );

  useEffect(() => {
    if (load === null) {
      setLoad(true);
    } else {
      setLoad(false);
    }
  }, [categoryImgInfo]);

  const loadMore = useCallback(() => {
    if (!categoryImgInfo.load && categoryImgInfo.list.length < categoryImgInfo.pagenation.count) {
      const params = {
        ...categoryImgInfo.pagenation,
      };
      delete params.count;
      dispatch(
        getCategoryImgInfo({
          ...params,
          classId: activeClass,
          tagId: activeTag,
          priceId: activePrice,
          skip: categoryImgInfo.list.length,
          refresh: false,
        }),
      );
    }
  }, [categoryImgInfo, activeClass, activeTag]);

  const DefaultCard = () => {
    return <div className={styles.default_img} />;
  };

  const Header = () => {
    return (
      <>
        <div className={styles.label}>
          <WallpaperCategoryNav
            list={classList}
            handleCategory={handleClass}
            active={activeClass}
            text="分类"
            keyId="classifyId"
            keyName="classifyName"
            keyWord="class"
          />
          <WallpaperCategoryNav
            list={tagList}
            handleCategory={handleTag}
            active={activeTag}
            text="标签"
            keyId="tagId"
            keyName="tagName"
            keyWord="tag"
          />
          <WallpaperCategoryNav
            list={priceList}
            handleCategory={handlePrice}
            active={activePrice}
            text="资费"
            keyId="priceId"
            keyName="priceName"
            keyWord="price"
          />
        </div>
      </>
    );
  };
  if ((load || load === null) && action !== 'POP') {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }
  return (
    <div
      className={styles.page}
      ref={r => {
        setPageContent(r);
      }}
    >
      {/* <div className={styles.nav}>
        <div className={styles.nav_container}>
          <Nav active="wpcategory" />
        </div>
      </div> */}

      <div className={styles.page_container}>
        <InfiniteScroll
          dataSource={categoryImgInfo.list || []} // 数据集
          count={categoryImgInfo.pagenation.count}
          gap={10}
          columnWidth={columnWidth}
          columnCountByScreen={columnCountByScreen}
          getItemSize={index => {
            const commonHeight = (columnMap[columnWidth[index % 3]] || 190) + 15;
            const defaultHeaderHeight =
              (Math.ceil(classList.length / 9) + Math.ceil(tagList.length / 9)) * 32 + 14 + 6;
            // eslint-disable-next-line radix
            let tpl = +parseInt((columnMap && columnMap.tpl) || 0);
            if (tpl < 84) {
              tpl = defaultHeaderHeight;
            }
            const temp = index === 0 ? commonHeight + tpl : commonHeight;
            return temp;
          }} // 行高
          loadData={loadMore}
          getHeight={param => setColumnMap(param)}
          template={(item, index) => {
            return (
              <WallpaperCard
                wallpaper={item}
                key={index}
                virtualScroll={true}
                cardInfo={{
                  pageSource: 'category',
                  classId: activeClass,
                  tagId: activeTag,
                  isCollect: true,
                  isWallpaper: true,
                  isDeleteColl: false,
                  isDeleteUsed: false,
                  isPreview: true,
                  classType: 'fit_space',
                  allData: categoryImgInfo.list || [],
                }}
                logInfo={{
                  source: `Wallpaper_Category||${activeClass}||${activeTag}||${activePrice}`,
                }}
                isFit={true}
                node={pageContent}
              />
            );
          }}
          tpl={Header}
          resizeTemplate={DefaultCard}
          blank={() => <Blank load={categoryImgInfo.load} more />}
          isWpPage={true}
        />
        <div className={styles.right_control}>
          <ScrollTopWhite node={el} quickly={true} />
          {batchAddBtn.isShow && (
            <BatchAdd
              scollNode={el}
              text={batchText}
              submitJson={{ groupType: 2, classifyId: activeClass, tagId: activeTag }}
              source={`Wallpaper_Category||${activeClass}||${activeTag}||${activePrice}`}
              loginTag={() => setOnLogin(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default () => {
  const history = useHistory();
  const { refresh } = useAliveController();

  useEffect(() => {
    if (history.action === 'PUSH') {
      refresh(`wpcateg`);
    }
  }, []);
  return (
    <KeepAlive name="wpcateg">
      <WPCategory />
    </KeepAlive>
  );
};
